import { getBaseMenu } from 'shared/models/api';
import SmallBeer from 'images/storefront/beer-mobile.png';
import SmallWine from 'images/storefront/wine-mobile.png';
import SmallSpirits from 'images/storefront/spirits-mobile.png';
import SmallSnacks from 'images/storefront/snacks-mobile.png';

const FEATURED_IMAGES_LOADING = 'FEATURED_IMAGES_LOADING';
const FEATURED_IMAGES_LOADED = 'FEATURED_IMAGES_LOADED';
const CURATIONS_LOADING = 'CURATIONS_LOADING';
const CURATIONS_LOADED = 'CURATIONS_LOADED';

const init = {
  featuredImagesLoading: false,
  curationsLoading: false,
  featured: {
    carousel: [],
    tiles: [
      {
        name: 'Beer',
        tag: 'BE',
        small_image: SmallBeer
      },
      {
        name: 'Wine',
        tag: 'WN',
        small_image: SmallWine
      },
      {
        name: 'Spirits',
        tag: 'ST',
        small_image: SmallSpirits
      },
      {
        name: 'More',
        url: '/more',
        tag: 'OT',
        small_image: SmallSnacks
      }
    ]
  },
  curations: []
};

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case FEATURED_IMAGES_LOADING:
      return { ...state, featuredImagesLoading: true };
    case FEATURED_IMAGES_LOADED:
      return {
        ...state,
        featuredImagesLoading: false,
        featured: {
          ...state.featured,
          carousel: action.featured_images
        }
      };
    case CURATIONS_LOADING:
      return { ...state, curationsLoading: true };
    case CURATIONS_LOADED:
      return { ...state, curationsLoading: false, curations: action.curations };
    default:
      return state;
  }
}

export function getFeatured() {
  return dispatch => {
    dispatch({ type: FEATURED_IMAGES_LOADING });
    return getBaseMenu({ featuredImages: true }).then(({ featured_images }) => {
      dispatch({ type: FEATURED_IMAGES_LOADED, featured_images });
    });
  };
}

export function getCurations() {
  return dispatch => {
    dispatch({ type: CURATIONS_LOADING });
    return getBaseMenu({ curations: true }).then(({ curations }) => {
      dispatch({ type: CURATIONS_LOADED, curations });
    });
  };
}

export function getFeaturedAndCurations() {
  return dispatch => {
    dispatch({ type: FEATURED_IMAGES_LOADING });
    dispatch({ type: CURATIONS_LOADING });
    return getBaseMenu({
      featuredImages: true,
      curations: true
    }).then(({ featured_images, curations }) => {
      dispatch({ type: FEATURED_IMAGES_LOADED, featured_images });
      dispatch({ type: CURATIONS_LOADED, curations });
    });
  };
}
